/* landing-countdown-timer.js v1.0.0
 * Custom element: <landing-countdown-timer>
 * Gerçek tarih bazlı, timezone-aware. Fake countdown YASAK (CLAUDE.md honest defaults).
 * data-end-time   : ISO 8601 string (YYYY-MM-DDTHH:MM:SS), customizer'dan gelir
 * data-timezone   : "visitor" (browser local) | "fixed" (UTC + offset)
 * data-utc-offset : number (-12…+12), data-timezone="fixed" için
 * data-behavior   : "hide" | "restart" | "next_day"
 * data-repeat-hours: number (restart mode için tekrar süresi)
 * data-show-days, data-show-hours, data-show-minutes, data-show-seconds: "true"/"false"
 */
class LandingCountdownTimer extends HTMLElement {
  connectedCallback() {
    const raw = this.dataset.endTime;
    if (!raw) { this.style.display = 'none'; return; }

    this.behavior   = this.dataset.behavior   || 'hide';
    this.repeatMs   = (parseFloat(this.dataset.repeatHours) || 24) * 3600000;
    this.showDays   = this.dataset.showDays   !== 'false';
    this.showHours  = this.dataset.showHours  !== 'false';
    this.showMins   = this.dataset.showMinutes !== 'false';
    this.showSecs   = this.dataset.showSeconds !== 'false';

    this.endTime = this._parseEndTime(raw, this.dataset.timezone, parseFloat(this.dataset.utcOffset) || 0);
    if (!this.endTime) { this.style.display = 'none'; return; }

    this._update();
    this._interval = setInterval(this._update.bind(this), 1000);
  }

  disconnectedCallback() {
    clearInterval(this._interval);
  }

  /**
   * Kabul edilen biçimler (2026-09-16 — Mehmet canlıda buldu):
   *   2026-09-25T16:22:30  → tam
   *   2026-09-25T16:22     → saniye 00 sayılır
   *   2026-09-25           → o günün SONU (23:59:59) sayılır — kampanya bitişi
   *                          gün seçilerek giriliyor, saat/saniye önemli değil
   * Öncesinde saniye ZORUNLUYDU: saniyesiz tarih giren merchant'ta regex
   * eşleşmiyor, `null` dönüyor ve blok SESSİZCE gizleniyordu (satır ~25) —
   * merchant sayacın neden kaybolduğunu göremiyordu.
   * Saat 24'ten büyük / ay 13 gibi saçma değerler hâlâ reddedilir.
   */
  _parseEndTime(str, timezone, offset) {
    var m = String(str || '').trim()
      .match(/^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2})(?::(\d{2}))?)?$/);
    if (!m) return null;
    var dateOnly = m[4] === undefined;
    var Y = +m[1], Mo = +m[2] - 1, D = +m[3];
    var H = dateOnly ? 23 : +m[4];
    var Mi = dateOnly ? 59 : +m[5];
    var S = dateOnly ? 59 : (m[6] === undefined ? 0 : +m[6]);
    if (Mo > 11 || D > 31 || H > 23 || Mi > 59 || S > 59) return null;
    if (timezone === 'fixed') {
      return new Date(Date.UTC(Y, Mo, D, H, Mi, S) - offset * 3600000);
    }
    return new Date(Y, Mo, D, H, Mi, S);
  }

  _update() {
    var diff = this.endTime - Date.now();

    if (diff <= 0) {
      this._onEnd();
      return;
    }

    var totalSecs = Math.floor(diff / 1000);
    var days    = Math.floor(totalSecs / 86400);
    var hours   = Math.floor((totalSecs % 86400) / 3600);
    var minutes = Math.floor((totalSecs % 3600) / 60);
    var seconds = totalSecs % 60;

    this._set('days',    days,    this.showDays);
    this._set('hours',   hours,   this.showHours);
    this._set('minutes', minutes, this.showMins);
    this._set('seconds', seconds, this.showSecs);
  }

  _set(unit, val, show) {
    var el = this.querySelector('[data-unit="' + unit + '"]');
    if (!el) return;
    el.style.display = show ? '' : 'none';
    var num = el.querySelector('.lct-number');
    if (num) num.textContent = String(val).padStart(2, '0');
    el.setAttribute('aria-label', val + ' ' + unit);
  }

  _onEnd() {
    clearInterval(this._interval);
    if (this.behavior === 'restart') {
      this.endTime = new Date(this.endTime.getTime() + this.repeatMs);
      this._interval = setInterval(this._update.bind(this), 1000);
      this._update();
    } else if (this.behavior === 'next_day') {
      this.endTime.setDate(this.endTime.getDate() + 1);
      this._interval = setInterval(this._update.bind(this), 1000);
      this._update();
    } else {
      // hide (default)
      var wrapper = this.closest('.landing-countdown');
      if (wrapper) wrapper.style.display = 'none';
      else this.style.display = 'none';
    }
  }
}

if (!customElements.get('landing-countdown-timer')) {
  customElements.define('landing-countdown-timer', LandingCountdownTimer);
}
